<mat-tab-group (selectedTabChange)="tabClicked($event)" [(selectedIndex)]="ActiveTab" mat-stretch-tabs class="tab_group">
    <mat-tab label="NEW" class="tab_content" *ngIf="persistenceService.get('addDisable') == 'true'">
        <form class="global-form" (ngSubmit)="saveGatePass($event)" [formGroup]="newForm">
            <div class="flex-row" >
                <mat-card appearance="outlined" class="contain_card flex-20">
                    <mat-form-field appearance="fill" >
                        
<mat-label>Company</mat-label>
<input class="global-input" matInput required readonly value="{{defaultCompany}}" formControlName="company_id" [(ngModel)]="gatePass.company_id" />
                    </mat-form-field>
                </mat-card>
                <mat-card appearance="outlined" class="contain_card flex-20">
                    <mat-form-field appearance="fill"  class="field-full-width">
                        
<mat-label>Gate Pass No</mat-label>
<input class="global-input" matInput required *ngFor="let maxgatepassno of maxgatepasses | async" value="{{maxgatepassno.id}}" readonly id="ref_no" name="ref_no" formControlName="ref_no" [(ngModel)]="gatePass.ref_no" />
                    </mat-form-field>
                </mat-card>

                <mat-card appearance="outlined" class="contain_card flex-20">
                    <mat-form-field appearance="fill"  class="field-full-width">
                        
<mat-label>Pass Date</mat-label>
<input class="global-input" matInput required readonly value="{{gatePass.gatepass_date}}" />
                    </mat-form-field>
                </mat-card>
                <mat-card appearance="outlined" class="contain_card flex-20">
                    <mat-form-field appearance="fill"  class="field-full-width">
                        
<mat-label>Pass Time</mat-label>
<input class="global-input" matInput required readonly value="{{gatePass.gatepass_time}}" />
                    </mat-form-field>
                </mat-card>
                <mat-card appearance="outlined" class="company_card" class="flex-20">
                    <mat-form-field appearance="fill"  class="selectOption">
                        
<mat-label>Select Appointment No</mat-label>
<mat-select panelClass="custom-select-panel" (selectionChange)="onCreateGatePassSelect($event.value)" formControlName="visitor_ref_no" [(ngModel)]="gatePass.visitor_ref_no">
                            <mat-option *ngFor="let appoint of appointmentList" value={{appoint.ref_no}}>
                                {{appoint.ref_no}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-card>
            </div>
            <!--View the data depending on Appointment No-->
            <mat-card appearance="outlined" class="mat_card" *ngIf="viewDataEntryAvail">
                <fieldset class="field_set">
                    <legend class="legend">Appointment Details</legend>
                    <div class="flex-row" >
                        <mat-card appearance="outlined" class="contain_card flex-20">
                            <mat-form-field appearance="fill"  class="field-full-width">
                                
<mat-label>Whom To Meet</mat-label>
<input class="global-input" matInput readonly (value)="viewAppointment.whomto_meet" />
                            </mat-form-field>
                        </mat-card>
                        <mat-card appearance="outlined" class="contain_card flex-20">
                            <mat-form-field appearance="fill"  class="field-full-width">
                                
<mat-label>Appointment Type</mat-label>
<input class="global-input" matInput readonly (value)="viewAppointment.appointment_type" />
                            </mat-form-field>
                        </mat-card>
                        <mat-card appearance="outlined" class="contain_card flex-20">
                            <mat-form-field appearance="fill"  class="field-full-width">
                                
<mat-label>Appointment Fixed By</mat-label>
<input class="global-input" matInput readonly (value)="viewAppointment.appointment_fixed_by" />
                            </mat-form-field>
                        </mat-card>
                        <mat-card appearance="outlined" class="contain_card flex-40">
                            <mat-form-field appearance="fill"  class="field-full-width">
                                
<mat-label>Purpose</mat-label>
<input class="global-input" matInput readonly (value)="viewAppointment.purpose" />
                            </mat-form-field>
                        </mat-card>
                    </div>
                    <div class="flex-row" >
                        <mat-card appearance="outlined" class="contain_card flex-20">
                            <mat-form-field appearance="fill"  class="field-full-width">
                                
<mat-label>Schedule Date & Time</mat-label>
<input class="global-input" matInput readonly (value)="viewAppointment.schedule_date_from + ', ' + viewAppointment.schedule_time_from" />
                            </mat-form-field>
                        </mat-card>
                        <mat-card appearance="outlined" class="contain_card flex-20">
                            <mat-form-field appearance="fill"  class="field-full-width">
                                
<mat-label>Visitor Name</mat-label>
<input class="global-input" matInput readonly (value)="viewAppointment.visitor_name" />
                            </mat-form-field>
                        </mat-card>
                        <mat-card appearance="outlined" class="contain_card flex-20">
                            <mat-form-field appearance="fill"  class="field-full-width">
                                
<mat-label>From Company</mat-label>
<input class="global-input" matInput readonly (value)="viewAppointment.visitor_company" />
                            </mat-form-field>
                        </mat-card>
                        <mat-card appearance="outlined" class="contain_card flex-20">
                            <mat-form-field appearance="fill"  class="field-full-width">
                                
<mat-label>Address</mat-label>
<input class="global-input" matInput readonly (value)="viewAppointment.address +', '+ viewAppointment.city+', '+ viewAppointment.state+', '+ viewAppointment.country" />
                            </mat-form-field>
                        </mat-card>
                        <mat-card appearance="outlined" class="contain_card flex-20">
                            <mat-form-field appearance="fill"  class="field-full-width">
                                
<mat-label>Visitor Mobile No</mat-label>
<input class="global-input" matInput readonly (value)="viewAppointment.visitor_mobile_no" />
                            </mat-form-field>
                        </mat-card>
                    </div>
                </fieldset>
            </mat-card>
            <mat-card appearance="outlined" class="mat_card" *ngIf="viewDataEntryAvail">
                <fieldset class="field_set">
                    <legend class="legend">Entry Details</legend>
                    <div class="flex-row" >

                        <mat-card appearance="outlined" class="contain_card flex-25">
                            <mat-form-field appearance="fill"  class="field-full-width">
                                
<mat-label>Vehicle No</mat-label>
<input class="global-input" matInput required [(ngModel)]="gatePass.vehicle_no" #veh (keyup)="checkDataVeh(veh.value)" formControlName="vehicle_no" />
                            </mat-form-field>
                        </mat-card>
                        <mat-card appearance="outlined" class="contain_card flex-25">
                            <mat-form-field appearance="fill"  class="field-full-width">
                                
<mat-label>No of Packets (If Any)</mat-label>
<input class="global-input" matInput required [(ngModel)]="gatePass.no_of_packets_if_any" #pac (keyup)="checkDataPac(pac.value)" formControlName="no_of_packets_if_any" />
                            </mat-form-field>
                        </mat-card>
                        <mat-card appearance="outlined" class="contain_card flex-50">
                            <mat-form-field appearance="fill"  class="field-full-width">
                                
<mat-label>Remarks (If Any)</mat-label>
<input class="global-input" matInput required [(ngModel)]="gatePass.remarks_if_any" #rem (keyup)="checkDataRem(rem.value)" formControlName="remarks_if_any" />
                            </mat-form-field>
                        </mat-card>
                    </div>
                    <div class="flex-row" >
                        <mat-card appearance="outlined" class="contain_card flex-25">
                            <mat-form-field appearance="fill"  class="field-full-width">

                                
<mat-label>Enter OTP Sent</mat-label>
<input class="global-input" matInput required [(ngModel)]="gatePass.otp_received" #otp (keyup)="checkOTPReceive(otp.value)" formControlName="otp_received" />
                            </mat-form-field>
                        </mat-card>

                        <mat-card appearance="outlined" class="contain_card flex-25">
                            <mat-form-field appearance="fill"  class="field-full-width">
                                
<mat-label>Employee Permitted Through</mat-label>
<mat-select panelClass="custom-select-panel" formControlName="employee_permitted_through" required [(ngModel)]="gatePass.employee_permitted_through">
                                    <mat-option *ngFor="let permittedThrough of modeOfPermission" [value]="permittedThrough">
                                        {{permittedThrough}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </mat-card>
                        <mat-card appearance="outlined" class="contain_card flex-25">
                            <mat-form-field appearance="fill"  class="field-full-width">
                                
<mat-label>Employee Permitted</mat-label>
<mat-select panelClass="custom-select-panel" formControlName="employee_permitted" required [(ngModel)]="gatePass.employee_permitted">
                                    <mat-option *ngFor="let yesNoLs of yesNoList" [value]="yesNoLs">
                                        {{yesNoLs}}</mat-option>
                                </mat-select>

                            </mat-form-field>
                        </mat-card>
                        <mat-card appearance="outlined" class="contain_card flex-25">
                            <mat-form-field appearance="fill"  class="field-full-width">
                                
<mat-label>Employee Message</mat-label>
<input class="global-input" matInput required [(ngModel)]="gatePass.employee_message" formControlName="employee_message" />
                            </mat-form-field>
                        </mat-card>
                    </div>
                </fieldset>

                <div>
                    <mat-card-actions style="min-width: 120px; float: left;">
                        <button class="global-button" type="button" disabled="{{disableOTPButton}}" (click)="generateOTP()">Generate
                OTP</button>
                    </mat-card-actions>&nbsp;
                    <mat-card-actions style="min-width: 120px; float: left;">
                        <button class="global-button" type="button" disabled disabled="{{disablePassEmpButton}}" (click)="askedToEmployee()">Ask
                For Permission</button>
                    </mat-card-actions>
                </div>
                <mat-form-field appearance="fill"  [hidden]="true">
                    <input class="global-input" matInput type="text" formControlName="otp_generated" [(ngModel)]="gatePass.otp_generated">
                </mat-form-field>


                <mat-card-actions style="min-width: 120px; float: right;">
                    <button class="global-button" id="btnn">Save & Generate Pass</button>
                </mat-card-actions>
            </mat-card>
        </form>
    </mat-tab>
    <!--////////////////////VIEW GATEPASS ////////////////////////-->
    <mat-tab label="VIEW" class="tab_content" *ngIf="persistenceService.get('viewDisable') == 'true'">
        <div class="view_div" *ngIf="viewDataAvail">
            <mat-card appearance="outlined" class="view_card">
                <table mat-table [dataSource]="GatePassAppointmentList" class="mat-elevation-z8">
                    <!-- Appointment Type-->
                    <ng-container matColumnDef="ref_no">
                        <th mat-header-cell *matHeaderCellDef>Ref. No.</th>
                        <td mat-cell *matCellDef="let element"> {{element.ref_no}} </td>
                    </ng-container>
                    <ng-container matColumnDef="gatepass_date">
                        <th mat-header-cell *matHeaderCellDef>Date</th>
                        <td mat-cell *matCellDef="let element"> {{element.gatepass_date}} </td>
                    </ng-container>
                    <ng-container matColumnDef="gatepass_time">
                        <th mat-header-cell *matHeaderCellDef>Time</th>
                        <td mat-cell *matCellDef="let element"> {{element.gatepass_time}} </td>
                    </ng-container>
                    <ng-container matColumnDef="visitor_name">
                        <th mat-header-cell *matHeaderCellDef>Visitor Name</th>
                        <td mat-cell *matCellDef="let element"> {{element.visitor_name}} </td>
                    </ng-container>
                    <ng-container matColumnDef="visitor_company">
                        <th mat-header-cell *matHeaderCellDef>Company</th>
                        <td mat-cell *matCellDef="let element"> {{element.visitor_company}} </td>
                    </ng-container>
                    <ng-container matColumnDef="address">
                        <th mat-header-cell *matHeaderCellDef>Address</th>
                        <td mat-cell *matCellDef="let element"> {{element.address}} </td>
                    </ng-container>
                    <ng-container matColumnDef="purpose">
                        <th mat-header-cell *matHeaderCellDef>Purpose</th>
                        <td mat-cell *matCellDef="let element"> {{element.purpose}} </td>
                    </ng-container>
                    <ng-container matColumnDef="vehicle_no">
                        <th mat-header-cell *matHeaderCellDef>Vehicle No</th>
                        <td mat-cell *matCellDef="let element"> {{element.vehicle_no}} </td>
                    </ng-container>
                    <ng-container matColumnDef="no_of_packets_if_any">
                        <th mat-header-cell *matHeaderCellDef>Packets</th>
                        <td mat-cell *matCellDef="let element"> {{element.no_of_packets_if_any}} </td>
                    </ng-container>
                    <ng-container matColumnDef="employee_permitted">
                        <th mat-header-cell *matHeaderCellDef>Permission</th>
                        <td mat-cell *matCellDef="let element"> {{element.employee_permitted}} </td>
                    </ng-container>
                    <ng-container matColumnDef="employee_message">
                        <th mat-header-cell *matHeaderCellDef>Message</th>
                        <td mat-cell *matCellDef="let element"> {{element.employee_message}} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="viewtableColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: viewtableColumns;"></tr>
                </table>
            </mat-card>
        </div>
    </mat-tab>






    <!--////////////////////EDIT APPOINTMENT ////////////////////////-->
    <mat-tab label="EDIT" class="tab_content" *ngIf="persistenceService.get('editDisable') == 'true'">
        <div class="head_div" class="flex-row" >
            <mat-card appearance="outlined" class="company_card" class="flex-50">
                <mat-form-field appearance="fill" >
                    
<mat-label>Company</mat-label>
<input class="global-input" matInput required readonly value="{{defaultCompany}}" formControlName="company_id" />
                </mat-form-field>
            </mat-card>
            <mat-card appearance="outlined" class="company_card" class="flex-50">
                <mat-form-field appearance="fill"  class="selectOption">
                    
<mat-label>Select Gate Pass No</mat-label>
<mat-select panelClass="custom-select-panel" (selectionChange)="onEditGatePassSelect($event.value)">
                        <mat-option *ngFor="let gatePassList of GatePassList" value={{gatePassList.ref_no}}>{{gatePassList.ref_no}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-card>
        </div>

        <!-- EDIT FORM BEGIN-->


        <form class="global-form" (ngSubmit)="saveEditGatePass($event)" [formGroup]="editForm">
            <div class="view_div" *ngIf="editDataAvail">
                <div class="flex-row" >
                    <mat-card appearance="outlined" class="contain_card flex-20">
                        <mat-form-field appearance="fill" >
                            
<mat-label>Company</mat-label>
<input class="global-input" matInput required readonly value="{{defaultCompany}}" formControlName="company_id" [(ngModel)]="editGatePass.company_id" />
                        </mat-form-field>
                    </mat-card>
                    <mat-card appearance="outlined" class="contain_card flex-20">
                        <mat-form-field appearance="fill"  class="field-full-width">
                            
<mat-label>Gate Pass No</mat-label>
<input class="global-input" matInput required value="{{editGatePass.ref_no}}" readonly id="ref_no" name="ref_no" formControlName="ref_no" [(ngModel)]="editGatePass.ref_no" />
                        </mat-form-field>
                    </mat-card>
                    <mat-card appearance="outlined" class="contain_card flex-20">
                        <mat-form-field appearance="fill"  class="field-full-width">
                            
<mat-label>Pass Date</mat-label>
<input class="global-input" matInput required readonly value="{{editGatePass.gatepass_date}}" />
                        </mat-form-field>
                    </mat-card>
                    <mat-card appearance="outlined" class="contain_card flex-20">
                        <mat-form-field appearance="fill"  class="field-full-width">
                            
<mat-label>Pass Time</mat-label>
<input class="global-input" matInput required readonly value="{{editGatePass.gatepass_time}}" />
                        </mat-form-field>
                    </mat-card>
                    <mat-card appearance="outlined" class="company_card" class="flex-20">
                        <mat-form-field appearance="fill"  class="selectOption">
                            
<mat-label>Select Appointment No</mat-label>
<mat-select panelClass="custom-select-panel" (value)="defviewAppointmentNo" (selectionChange)="onEditGatePassAppointmentSelect($event.value)" [(ngModel)]="editGatePass.visitor_ref_no">
                                <mat-option *ngFor="let appoint of appointmentList" value={{appoint.ref_no}}>
                                    {{appoint.ref_no}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </mat-card>
                </div>
                <mat-card appearance="outlined" class="mat_card" *ngIf="editDataAvail">
                    <fieldset class="field_set">
                        <legend class="legend">Appointment Details</legend>
                        <div class="flex-row" >
                            <mat-card appearance="outlined" class="contain_card flex-20">
                                <mat-form-field appearance="fill"  class="field-full-width">
                                    
<mat-label>Whom To Meet</mat-label>
<input class="global-input" matInput readonly (value)="viewAppointment.whomto_meet" />
                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-20">
                                <mat-form-field appearance="fill"  class="field-full-width">
                                    
<mat-label>Appointment Type</mat-label>
<input class="global-input" matInput readonly (value)="viewAppointment.appointment_type" />
                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-20">
                                <mat-form-field appearance="fill"  class="field-full-width">
                                    
<mat-label>Appointment Fixed By</mat-label>
<input class="global-input" matInput readonly (value)="viewAppointment.appointment_fixed_by" />
                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-40">
                                <mat-form-field appearance="fill"  class="field-full-width">
                                    
<mat-label>Purpose</mat-label>
<input class="global-input" matInput readonly (value)="viewAppointment.purpose" />
                                </mat-form-field>
                            </mat-card>
                        </div>
                        <div class="flex-row" >
                            <mat-card appearance="outlined" class="contain_card flex-20">
                                <mat-form-field appearance="fill"  class="field-full-width">
                                    
<mat-label>Schedule Date & Time</mat-label>
<input class="global-input" matInput readonly (value)="viewAppointment.schedule_date_from + ', ' + viewAppointment.schedule_time_from" />
                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-20">
                                <mat-form-field appearance="fill"  class="field-full-width">
                                    
<mat-label>Visitor Name</mat-label>
<input class="global-input" matInput readonly (value)="viewAppointment.visitor_name" />
                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-20">
                                <mat-form-field appearance="fill"  class="field-full-width">
                                    
<mat-label>From Company</mat-label>
<input class="global-input" matInput readonly (value)="viewAppointment.visitor_company" />
                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-20">
                                <mat-form-field appearance="fill"  class="field-full-width">
                                    
<mat-label>Address</mat-label>
<input class="global-input" matInput readonly (value)="viewAppointment.address +', '+ viewAppointment.city+', '+ viewAppointment.state+', '+ viewAppointment.country" />
                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-20">
                                <mat-form-field appearance="fill"  class="field-full-width">
                                    
<mat-label>Visitor Mobile No</mat-label>
<input class="global-input" matInput readonly (value)="viewAppointment.visitor_mobile_no" />
                                </mat-form-field>
                            </mat-card>
                        </div>
                    </fieldset>
                </mat-card>

                <mat-card appearance="outlined" class="mat_card" *ngIf="editDataAvail">
                    <fieldset class="field_set">
                        <legend class="legend">Entry Details</legend>
                        <div class="flex-row" >

                            <mat-card appearance="outlined" class="contain_card flex-25">
                                <mat-form-field appearance="fill"  class="field-full-width">
                                    
<mat-label>Vehicle No</mat-label>
<input class="global-input" matInput required [(ngModel)]="editGatePass.vehicle_no" #veh (keyup)="checkDataVeh(veh.value)" formControlName="vehicle_no" />
                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-25">
                                <mat-form-field appearance="fill"  class="field-full-width">
                                    
<mat-label>No of Packets (If Any)</mat-label>
<input class="global-input" matInput required [(ngModel)]="editGatePass.no_of_packets_if_any" #pac (keyup)="checkDataPac(pac.value)" formControlName="no_of_packets_if_any" />
                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-50">
                                <mat-form-field appearance="fill"  class="field-full-width">
                                    
<mat-label>Remarks (If Any)</mat-label>
<input class="global-input" matInput required [(ngModel)]="editGatePass.remarks_if_any" #rem (keyup)="checkDataRem(rem.value)" formControlName="remarks_if_any" />
                                </mat-form-field>
                            </mat-card>
                        </div>
                        <div class="flex-row" >
                            <mat-card appearance="outlined" class="contain_card flex-25">
                                <mat-form-field appearance="fill"  class="field-full-width">

                                    
<mat-label>Enter OTP Sent</mat-label>
<input class="global-input" matInput required [(ngModel)]="editGatePass.otp_received" #otp (keyup)="checkOTPReceive(otp.value)" formControlName="otp_received" />
                                </mat-form-field>
                            </mat-card>

                            <mat-card appearance="outlined" class="contain_card flex-25">
                                <mat-form-field appearance="fill"  class="field-full-width">
                                    
<mat-label>Employee Permitted Through</mat-label>
<mat-select panelClass="custom-select-panel" formControlName="employee_permitted_through" required [(ngModel)]="editGatePass.employee_permitted_through">
                                        <mat-option *ngFor="let permittedThrough of modeOfPermission" [value]="permittedThrough">
                                            {{permittedThrough}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-25">
                                <mat-form-field appearance="fill"  class="field-full-width">
                                    
<mat-label>Employee Permitted</mat-label>
<mat-select panelClass="custom-select-panel" formControlName="employee_permitted" required [(ngModel)]="editGatePass.employee_permitted">
                                        <mat-option *ngFor="let yesNoLs of yesNoList" [value]="yesNoLs">
                                            {{yesNoLs}}</mat-option>
                                    </mat-select>

                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-25">
                                <mat-form-field appearance="fill"  class="field-full-width">
                                    
<mat-label>Employee Message</mat-label>
<input class="global-input" matInput required [(ngModel)]="editGatePass.employee_message" formControlName="employee_message" />
                                </mat-form-field>
                            </mat-card>
                        </div>
                    </fieldset>

                    <div>
                        <mat-card-actions style="min-width: 120px; float: left;">
                            <button class="global-button" type="button" disabled="{{disableOTPButton}}" (click)="generateOTP()">Generate
                  OTP</button>
                        </mat-card-actions>&nbsp;
                        <mat-card-actions style="min-width: 120px; float: left;">
                            <button class="global-button" type="button" disabled disabled="{{disablePassEmpButton}}" (click)="askedToEmployee()">Ask
                  For Permission</button>
                        </mat-card-actions>
                    </div>
                    <mat-form-field appearance="fill"  [hidden]="true">
                        <input class="global-input" matInput type="text" formControlName="otp_generated" [(ngModel)]="editGatePass.otp_generated">
                    </mat-form-field>
                    <mat-card-actions style="min-width: 120px; float: right;">
                        <button class="global-button" id="btnn">Save & Generate Pass</button>
                    </mat-card-actions>
                </mat-card>






            </div>
        </form>
    </mat-tab>
    <!--////////////////////DELETE APPOINTMENT ////////////////////////-->
    <mat-tab label="DELETE" class="tab_content" *ngIf="persistenceService.get('cancelDisable') == 'true'">
        <div class="view_div" *ngIf="viewDataAvail">
            <mat-card appearance="outlined" class="view_card">
                <table mat-table [dataSource]="GatePassAppointmentList" class="mat-elevation-z8">
                    <!-- Appointment Type-->
                    <ng-container matColumnDef="ref_no">
                        <th mat-header-cell *matHeaderCellDef>Ref. No.</th>
                        <td mat-cell *matCellDef="let element"> {{element.ref_no}} </td>
                    </ng-container>
                    <ng-container matColumnDef="gatepass_date">
                        <th mat-header-cell *matHeaderCellDef>Date</th>
                        <td mat-cell *matCellDef="let element"> {{element.gatepass_date}} </td>
                    </ng-container>
                    <ng-container matColumnDef="gatepass_time">
                        <th mat-header-cell *matHeaderCellDef>Time</th>
                        <td mat-cell *matCellDef="let element"> {{element.gatepass_time}} </td>
                    </ng-container>
                    <ng-container matColumnDef="visitor_name">
                        <th mat-header-cell *matHeaderCellDef>Visitor Name</th>
                        <td mat-cell *matCellDef="let element"> {{element.visitor_name}} </td>
                    </ng-container>
                    <ng-container matColumnDef="visitor_company">
                        <th mat-header-cell *matHeaderCellDef>Company</th>
                        <td mat-cell *matCellDef="let element"> {{element.visitor_company}} </td>
                    </ng-container>
                    <ng-container matColumnDef="address">
                        <th mat-header-cell *matHeaderCellDef>Address</th>
                        <td mat-cell *matCellDef="let element"> {{element.address}} </td>
                    </ng-container>
                    <ng-container matColumnDef="purpose">
                        <th mat-header-cell *matHeaderCellDef>Purpose</th>
                        <td mat-cell *matCellDef="let element"> {{element.purpose}} </td>
                    </ng-container>
                    <ng-container matColumnDef="vehicle_no">
                        <th mat-header-cell *matHeaderCellDef>Vehicle No</th>
                        <td mat-cell *matCellDef="let element"> {{element.vehicle_no}} </td>
                    </ng-container>
                    <ng-container matColumnDef="no_of_packets_if_any">
                        <th mat-header-cell *matHeaderCellDef>Packets</th>
                        <td mat-cell *matCellDef="let element"> {{element.no_of_packets_if_any}} </td>
                    </ng-container>
                    <ng-container matColumnDef="employee_permitted">
                        <th mat-header-cell *matHeaderCellDef>Permission</th>
                        <td mat-cell *matCellDef="let element"> {{element.employee_permitted}} </td>
                    </ng-container>
                    <ng-container matColumnDef="employee_message">
                        <th mat-header-cell *matHeaderCellDef>Message</th>
                        <td mat-cell *matCellDef="let element"> {{element.employee_message}} </td>
                    </ng-container>
                    <ng-container matColumnDef="cancel">
                        <th mat-header-cell *matHeaderCellDef> Cancel </th>
                        <td mat-cell *matCellDef="let element" (click)="onCancelGatePassAppointmentClick(element.ref_no)">
                            <i class="material-icons" style="cursor: pointer;">
                  cancel
                </i>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="deletetableColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: deletetableColumns;"></tr>
                </table>
            </mat-card>
        </div>
    </mat-tab>
</mat-tab-group>